const OrigoTheme = {
  backgroundColor: '#FFFFFF',
  borderColor: '#AAA',
  boxShadowColor: '#AAA',
  buttonBorder: '#2196F3',
  buttonPrimary: '#0A9E9C',
  danger: '#e74c3c',
  dangerLight: '#f4ada6',
  disabledColor: '#AAA',
  evenTableRow: '#F5F5F5',
  form: {
    formErrorColor: '#fccbc7',
    formErrorBorder: 'thin solid red',
    isVideoBackground: false,
  },
  formBackground: '#fefefe',
  iconColor: '#2196F3',
  primaryColor: '#2196F3',
  loginButtonPrimary: '#2196F3',
  loginButtonSecondary: 'white',
  logoSource: 'OrigoLogo.png',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryTextColor: 'black',
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px #AAA',
  },
  submitButton: '#1DA6CC',
  submitButtonActive: '#0a69b5',
  submitButtonHover: '#0c85e6',
  success: '#2ecc71',
  successLight: '#8CE5B2',
  textColor: 'black',
  // inputBackground: 'blue',
  inputColor: 'black',
};

const SparisjodurTheme = {
  backgroundColor: '#FFFFFF',
  borderColor: '#D1D1D1',
  boxShadowColor: '#AAA',
  buttonBorder: '#335c33',
  selectedItem: '#335c33',
  buttonPrimary: '#335c33',
  primaryColor: '#335c33',
  disabledColor: '#AAA',
  danger: '#e74c3c',
  dangerLight: '#f4ada6',
  evenTableRow: '#F5F5F5',
  form: {
    formErrorColor: '#fccbc7',
    formErrorBorder: 'thin solid red',
    isVideoBackground: false,
  },
  formBackground: '#fefefe',
  iconColor: '#335c33',
  loginButtonPrimary: '#335c33',
  loginButtonSecondary: 'white',
  logoSource: 'SpLogo.jpg',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryTextColor: '#333',
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px #AAA',
  },
  submitButton: '#335c33',
  submitButtonActive: '#008344',
  submitButtonHover: '#00944d',
  success: '#2ecc71',
  successLight: '#8CE5B2',
  textColor: 'black',
  selectedDanger: '#550000',
};

const SecondaryTheme = {
  backgroundColor: '#1E272E',
  borderColor: '#222',
  boxShadowColor: '#222',
  buttonBorder: '#B3894E',
  buttonPrimary: '#CBB492',
  danger: '#e74c3c',
  dangerLight: '#f4ada6',
  disabledColor: '#AAA',
  evenTableRow: '#242a2f',
  form: {
    formErrorColor: '#fccbc7',
    formErrorBorder: 'thin solid red',
    isVideoBackground: true,
  },
  formBackground: '#485460',
  iconColor: '#9A6F36',
  primaryColor: '#9A6F36',
  loginButtonPrimary: '#CBB492',
  loginButtonSecondary: 'white',
  logoSource: 'kvika.png',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryTextColor: 'white',
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px #AAA',
  },
  submitButton: '#CBB492',
  submitButtonActive: '#9c7b4a',
  submitButtonHover: '#bb9c70',
  success: '#2ecc71',
  successLight: '#8CE5B2',
  textColor: 'white',
  selectedDanger: '#550000',
};

const KvikaTheme = {
  backgroundColor: '#FFFFFF',
  borderColor: '#d5d5d5',
  boxShadowColor: '#666',
  buttonBorder: '#B3894E',
  buttonPrimary: '#A28352',
  danger: '#e74c3c',
  dangerLight: '#f4ada6',
  disabledColor: '#AAA',
  evenTableRow: '#F5F5F5',
  form: {
    formErrorColor: '#fccbc7',
    formErrorBorder: 'thin solid red',
    isVideoBackground: false,
  },
  formBackground: '#FFF',
  iconColor: '#A28352',
  loaderColor: '#A28352',
  loginButtonPrimary: '#A28352',
  loginButtonSecondary: 'white',
  logoSource: 'sitelogo.png',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryColor: '#A28352',
  primaryTextColor: 'black',
  secondaryColor: '#333333',
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px rgba(0,0,0,0.5)',
  },
  submitButton: '#CBB492',
  submitButtonActive: '#A28352',
  submitButtonHover: '#bb9c70',
  success: '#2ecc71',
  successLight: '#8CE5B2',
  textColor: 'black',
  // borderRadius: '8px',
  selectedDanger: '#550000',
};

const charcoalGray = '#353841';
const beige = '#f8ecdc';
const frenchBlue = '#466EAA';
const lightNavyBlue = '#314d87';
const darkMint = '#4CB872';
const paleOrange = '#ff9664';
const darkOrange = '#ff6e3c';

const rosyPink = '#f06478';
const sandyYellow = '#FBE777';

const AudurTheme = {
  primaryColor: charcoalGray,
  secondaryColor: beige,
  borderColor: 'transparent',
  boxShadowColor: '#AAA', // gray
  buttonBorder: '#2196F3', // light blue
  buttonPrimary: frenchBlue,
  themeBlue: frenchBlue,
  themeDarkBlue: lightNavyBlue,
  themeOrange: paleOrange,
  themeDarkOrange: darkOrange,
  themeGreen: darkMint,
  themeYellow: sandyYellow,
  themeRed: rosyPink,
  inputBackground: beige,
  inputColor: charcoalGray,
  danger: rosyPink,
  dangerLight: '#f4ada6', // very light red
  evenTableRow: '#F5F5F5', // white gray
  form: {
    formHeadingColor: beige,
    formErrorColor: rosyPink,
    formErrorBorder: `1px solid ${rosyPink}`,
    isVideoBackground: false,
    checkboxBackground: beige,
    radioButtonBackground: beige,
    radioButtonTickColor: charcoalGray,
    checkboxTickColor: charcoalGray,
  },
  formBackground: '#fefefe',
  iconColor: '#2196F3',
  loginButtonPrimary: '#466eaa',
  loginButtonSecondary: 'white',
  logoWSource: 'logoW.png',
  logoWIE11Source: 'logoWIE11.png',
  logoBSource: 'logoB.png',
  logoBIE11Source: 'logoBIE11.png',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryTextColor: beige,
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px #AAA',
  },
  submitButton: '#1DA6CC',
  submitButtonActive: sandyYellow,
  submitButtonHover: sandyYellow,
  success: '#2ecc71',
  successLight: '#8CE5B2',
  textColor: charcoalGray,
  customInputFontSize: '24px',
  buttonFontSize: 'inherit',
  disabledColor: '#AAA',
  infoBackground: '#FF9564',
};

const MedisTheme = {
  backgroundColor: '#FFFFFF',
  borderColor: '#dbdbdb',
  boxShadowColor: '#AAA',
  buttonBorder: '#59779f',
  buttonPrimary: '#0A9E9C',
  danger: '#ff2f49',
  dangerLight: '#f4ada6',
  evenTableRow: '#F5F5F5',
  disabledInputBackground: '#EEE',
  form: {
    formErrorColor: '#fccbc7',
    formErrorBorder: '1px solid red',
    isVideoBackground: false,
  },
  formBackground: '#fefefe',
  iconColor: '#59779f',
  loginButtonPrimary: '#59779f',
  loginButtonSecondary: 'white',
  logoSource: 'OrigoLogo.png',
  pieChartColors: ['#A28352', '#592D48', '#24405B', '#A8BAC6', '#B52D3D', '#0E777A'],
  primaryTextColor: 'black',
  sensetiveText: {
    color: 'transparent',
    textShadow: '0 0 10px #AAA',
  },
  submitButton: '#1DA6CC',
  submitButtonActive: '#0a69b5',
  submitButtonHover: '#0c85e6',
  success: '#64b764',
  successLight: '#8CE5B2',
  textColor: 'black',
};

export default {
  OrigoTheme,
  SecondaryTheme,
  KvikaTheme,
  SparisjodurTheme,
  AudurTheme,
  MedisTheme,
};
